document.addEventListener("DOMContentLoaded", (e) => {
  const isNotApple = () => {
    if (!/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
      return false;
    }
    return true;
  };

  const allowNumbersOnly = (e) => {
    var code = e.which ? e.which : e.keyCode;
    if (code > 31 && (code < 48 || code > 57)) {
      e.preventDefault();
    }
  };

  const dispatchChangeEvent = (stepper) => {
    stepper.dispatchEvent(new Event("input"));
    stepper.dispatchEvent(new Event("change"));
  };

  const steppers = document.querySelectorAll(".product-qty");
  steppers.forEach((stepper) => {
    const stepperInput = stepper.querySelector(".product-qty__input");
    const stepperBtnUp = stepper.querySelector(".product-qty__btn--up");
    const stepperBtnDown = stepper.querySelector(".product-qty__btn--down");

    let count = stepperInput.value;

    const getStepperLimit = () => {
      const min = parseInt(stepperInput.getAttribute("min"));
      const maxRaw = stepperInput.getAttribute("max");
      const max = maxRaw ? parseInt(maxRaw) : 999;

      const limit = { min, max };

      return limit;
    };

    const fixStepperWidthOnApple = () => {
      if (isNotApple) {
        stepperInput.style.width =
          stepperInput.value.length == 0
            ? `${stepperInput.value.length + 5}ex`
            : `${stepperInput.value.length + 4}ex`;
      } else {
        stepperInput.style.width =
          stepperInput.value.length == 0
            ? `${stepperInput.value.length + 6}ex`
            : `${stepperInput.value.length + 5}ex`;
      }
    };

    const updateStepperClass = (count) => {
      const stepperLimit = getStepperLimit();

      // Отключаю кнопку уменьшения, если количество 0 или 1
      if (count == stepperLimit.min) {
        stepperBtnDown.classList.add("product-qty__btn--disabled");
      } else {
        stepperBtnDown.classList.remove("product-qty__btn--disabled");
      }

      // Если количество больше либо равно, чем максимальное, отключает кнопку
      if (count >= stepperLimit.max) {
        stepperBtnUp.classList.add("product-qty__btn--disabled");
      }

      // Если количество меньше, чем максимальное, включает кнопку
      if (count < stepperLimit.max) {
        stepperBtnUp.classList.remove("product-qty__btn--disabled");
      }
    };

    updateStepperClass(count);

    stepperInput.addEventListener("keyup", (e) => {
      const stepperLimit = getStepperLimit();

      let self = e.currentTarget;

      if (self.value == "0") {
        self.value = 1;
      }

      if (self.value >= stepperLimit.max) {
        self.value = stepperLimit.max;
      }

      fixStepperWidthOnApple();

      count = stepperInput.value;

      updateStepperClass(count);
    });

    stepperInput.addEventListener("keypress", (e) => {
      allowNumbersOnly(e);
    });

    stepperInput.addEventListener("change", (e) => {
      const stepperLimit = getStepperLimit();

      let self = e.currentTarget;

      if (!self.value) {
        self.value = stepperLimit.min;
      }

      count = stepperInput.value;

      updateStepperClass(count);
    });

    stepperBtnUp.addEventListener("click", (e) => {
      e.preventDefault();

      count++;

      updateStepperClass(count);

      stepperInput.value = count;

      dispatchChangeEvent(stepper);

      fixStepperWidthOnApple();
    });

    stepperBtnDown.addEventListener("click", (e) => {
      e.preventDefault();

      const stepperLimit = getStepperLimit();

      count--;

      if (count >= stepperLimit.max) {
        count = stepperLimit.max;
      }

      updateStepperClass(count);

      stepperInput.value = count;
      dispatchChangeEvent(stepper);

      fixStepperWidthOnApple();
    });
  });
});
